import { useMemo } from "react";
import Fuse from "fuse.js";
import { useUsers } from "@api";

const STAFF_KEYS = ["name", "email", "role", "branch"];
const MAX_RESULTS = 6;

export default function useStaffSearch(term, { enabled = true, sort } = {}) {
  const { data: users = [], isLoading } = useUsers();

  const fuse = useMemo(
    () => new Fuse(users, { keys: STAFF_KEYS, threshold: 0.3 }),
    [users],
  );

  const trimmed = term.trim();
  const results = useMemo(() => {
    if (!enabled) return [];
    let matched = trimmed ? fuse.search(trimmed).map((r) => r.item) : users;
    // Alphabetical is opt-in so the composer's @-mention keeps its relevance/insertion order.
    if (sort === "alpha") {
      matched = [...matched].sort((a, b) => (a.name ?? "").localeCompare(b.name ?? ""));
    }
    return matched.slice(0, MAX_RESULTS);
  }, [enabled, trimmed, fuse, users, sort]);

  return { results, isLoading };
}
